import { Component, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ACustomerInfoComponent } from "../../components/forms/a-customer-info/a-customer-info.component";
import { CDocumentsFormComponent } from "../../components/forms/c-documents-form/c-documents-form.component";
import { BCategoryFormComponent } from "../../components/forms/b-category-form/b-category-form.component";
import { ETopCustomersComponent } from "../../components/forms/e-top-customers/e-top-customers.component";
import { FHealthSafetyComponent } from "../../components/forms/f-health-safety/f-health-safety.component";
import { DDirectorsAuthorityFormComponent } from "../../components/forms/d-directors-authority-form/d-directors-authority-form.component";
import { GTermsConditionsComponent } from "../../components/forms/g-terms-conditions/g-terms-conditions.component";
import { CommonModule, isPlatformBrowser, NgClass, NgFor, NgIf } from '@angular/common';
import { NavbarComponent } from "../../components/navbars/navbar/navbar.component";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { FormSubmitService } from '../../Services/Form Data/formsubmit.service';
import { catchError, concatMap, filter, finalize, forkJoin, from, Observable, of, switchMap, take, tap, throwError } from 'rxjs';
import { FormDataService } from '../../Services/Form Data/form-data.service';
import { describeHttpError, formatEmailDeliveryUserMessage, NotificationService } from '../../Services/Data Service/notification.service';
import { DataService } from '../../Services/Data Service/data.service';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../Auth/auth.service';
import { FormUpdateService } from '../../Services/Form Data/formupdate.service';
import { formatNameWithTitle, normalizeUserNameTitle } from '../../utils/name-title.util';

@Component({
  selector: 'app-start-form',
  standalone: true,
  imports: [
    ACustomerInfoComponent,
    CDocumentsFormComponent,
    NgFor, NgIf,
    BCategoryFormComponent,
    ETopCustomersComponent,
    FHealthSafetyComponent,
    DDirectorsAuthorityFormComponent,
    GTermsConditionsComponent,
    NavbarComponent, RouterModule
],
  templateUrl: './start-form.component.html',
  styleUrl: './start-form.component.css'
})
export class StartFormComponent {

  @ViewChild(ACustomerInfoComponent) aCustomerInfo!: ACustomerInfoComponent;
  @ViewChild(CDocumentsFormComponent) bDocumentsForm!: CDocumentsFormComponent;
  @ViewChild(DDirectorsAuthorityFormComponent) dDirectorsAuthorityForm!: DDirectorsAuthorityFormComponent;
  @ViewChild(ETopCustomersComponent) eTopCustomers!: ETopCustomersComponent;
  @ViewChild(FHealthSafetyComponent) fHealthSafety!: FHealthSafetyComponent;
  @ViewChild(GTermsConditionsComponent) gTermsConditions!: GTermsConditionsComponent;

  pages = [
    { component: 'aCustomerInfo' },
    { component: 'bDocumentsForm' },
    { component: 'dDirectorsAuthorityForm' },
    { component: 'fTopCustomers' },
    { component: 'hHealthSafety' },
    { component: 'iTermsConditions' },
  ];

  formData: any;
  submittedData: any;
  currCompanyID: any;
  currUser: any;
  currCompany: any;
  errorLoading = false;
  /** Shown when the main submit API chain fails (not email-only warnings). */
  submissionError = '';

  savedMessage ='';
  isClosingBanner: boolean = false;
  firstVisit = false;
  showRefreshBanner = true;

  loading: boolean = false;
  // loading: boolean[] = Array(12).fill(false);


  constructor(
    private formDataService: FormDataService, 
    private formSubmitService: FormSubmitService,
    private formUpdateService: FormUpdateService,
    private notificationService: NotificationService,
    private dataService: DataService,
    private router: Router,
    private auth: AuthService,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object
    
   ) {
    // this.formData = formDataService.getFormData();
    this.currCompanyID = formDataService.getCurrCompanyID();
    this.currUser = this.formDataService.getUserData;

  }

  isLightboxOpen = false;
  selectedVideoUrl: SafeResourceUrl = '';

  openLightbox(url: string): void {
    const hasQuery = url.includes('?');
    const params = [
      'autoplay=1',
      'enablejsapi=1',
      'origin=' + window.location.origin,
      'rel=0',
      'modestbranding=1'
    ];
    const paramString = params.join('&');
    const finalUrl = hasQuery 
      ? url + '&' + paramString 
      : url + '?' + paramString;
    this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(finalUrl);
    this.isLightboxOpen = true;
  }

  closeLightbox(): void {
    this.isLightboxOpen = false;
    this.selectedVideoUrl = '';
  }
  currentPage = 0;

  ngOnInit(){
    this.loading = true;


    if (isPlatformBrowser(this.platformId)) {
      const firstVisit = localStorage.getItem('firstVisit');
      if (firstVisit === 'true') {
        this.firstVisit = true; // Use this to show a toast/modal
        localStorage.removeItem('firstVisit'); // Clean up
      }
    }
    // Consume shared current user (set by app init or after login); no refetch.
    this.dataService.currentUser$.pipe(
      filter((u): u is NonNullable<typeof u> => u != null),
      take(1)
    ).subscribe({
      next: (loggedInUser) => {
        if (!loggedInUser.role) {
          console.error('User on start form not found.');
          this.loading = false;
          return;
        }
        this.currUser = loggedInUser;
        this.loading = false;
        this.loadUserData(this.currUser);
      },
      error: (error) => {
        console.error('Error fetching logged-in user:', error);
        this.loading = false;
      }
    });

  }

  async nextPage() {
    const currentComponent = this.getCurrentComponent();

    if (currentComponent && currentComponent.onSubmit) {
    const isValid = await currentComponent.onSubmit(); // Wait for async result
  
      if (!isValid) {
        return; // Stop navigation if form is invalid
      }
    }

    if (this.currentPage < this.pages.length - 1) {
      this.currentPage++;
    }

    // Scroll to top of page
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    this.savedMessage = "Changes saved!";
    this.isClosingBanner = false;

    setTimeout(() => {
      this.isClosingBanner = true;

      // Remove the banner after animation completes
      setTimeout(() => {
        this.savedMessage = '';
      }, 400); // match the closing animation duration
    }, 3000); // how long the banner stays visible

  }

  previousPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }

    // Scroll to top of page
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  companyName = '';

  async submit() { 
    const isValid = await this.gTermsConditions.onSubmit();

    if (!isValid) {
      return; // Stop here if validation failed
    }

    // Scroll to top of page
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

  if (confirm('Are you ready to submit?')) {
      
    this.loading = true;
    this.submissionError = '';

    const userData = this.formDataService.getUserData();

    //change role to Vendor, and status to Under Review; apply title to name only on confirmed submit
    const updatedUser = {
      ...userData,
      strName: formatNameWithTitle(userData.strTitle, userData.strName),
      role: 'Vendor',
      strAccountStatus: 'Under Review',
      strAccountStatusDate: this.dataService.getLocalDate()
    };

    this.formDataService.updateUserData(updatedUser);

    console.log('Submitting user data:', this.formDataService.getUserData());

    //SAVE MODIFIED user TO DB
    this.formUpdateService.updateUser(this.currUser.company.intCompanyPK).pipe(
      switchMap((response) => {
        console.log(response);
        this.companyName = this.formDataService.getCompanyData().strCompanyName;

        // Admin notification
        const adminPayload = {
          companyId: 1,
          adminId: this.formDataService.getCurrCompanyID(),
          message: `NEW Vendor Registration Form submission from ${this.companyName}. Navigate to Dashboard or Vendor Management page to review pending requests.`,
          type: 'new_vendor_registration',
          createdAt: new Date(this.dataService.getLocalDate()), //is overwritten in backend. date is set in api
          fieldNames: []
        };

        // Chain: sendNotification → sendEmailNotification → vendorEmail (email failures are non-blocking)
        const emailWarnings: string[] = [];
        return this.notificationService.sendNotification(adminPayload).pipe(
          switchMap(() =>
            this.notificationService.sendEmailNotification(
              "admin-submission",
              "NEW Vendor Registration Submission",
              "procurement@unipet.co"
            ).pipe(
              tap((emailRes) => {
                const line = formatEmailDeliveryUserMessage(emailRes, 'submission');
                if (line) {
                  emailWarnings.push(line);
                }
              })
            )
          ),
          switchMap(() =>
            this.sendVendorEmailNotification(this.currUser.company.intCompanyPK, 0).pipe(
              tap((emailRes) => {
                const line = formatEmailDeliveryUserMessage(emailRes, 'submission');
                if (line) {
                  emailWarnings.push(line);
                }
              })
            )
          ),
          tap(() => {
            const uniq = [...new Set(emailWarnings)];
            if (uniq.length > 0) {
              this.showSnackbar(uniq.join(' '));
            }
          })
        );
      })
    ).subscribe({
      next: () => {
        // ✅ Only runs after notifications + emails finish
        localStorage.setItem("submissionComplete", "true");
        this.router.navigate(["/login"]);
        // Remove tokens and user info
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('role');

        // Clear observables and form data
        this.formDataService.resetFormData();
        this.loading = false;
      },
      error: (error) => {
        console.error("Submission failed. Try again", error);
        this.submissionError = describeHttpError(error);
        this.loading = false;
      }
    });


  }

}

sendVendorEmailNotification(companyId: number, adminId: number): Observable<any> {
  //creates both in-app and email notification for account creation
  const payload = {
    companyId,
    adminId,
    type: "new_form_submission",
    message: "Form Submitted. Your submission has been received and is under review.",
    createdAt: new Date(this.dataService.getLocalDate()), //is overwritten in backend. date is set in api
    fieldNames: [] 
  };

  const subject = 'Form Submitted: UNIPET Vendor Registration.';

  return this.notificationService.sendNotification(payload).pipe(
    switchMap(() =>
      this.notificationService.sendEmailNotification(
        "form-submission",
        subject,
        this.currUser.strEmail
      )
    )
  );
}

private showSnackbar(message: string): void {
  const snackbar = document.getElementById('snackbar');

  if (snackbar) {
    const snackbarElement = snackbar as HTMLElement & { timeoutId?: number };

    if (snackbarElement.timeoutId) {
      clearTimeout(snackbarElement.timeoutId);
    }

    snackbarElement.style.visibility = 'visible';
    snackbarElement.style.opacity = '1';
    snackbarElement.innerText = message;
    snackbarElement.classList.add('show');

    snackbarElement.timeoutId = setTimeout(() => {
      snackbarElement.style.visibility = 'hidden';
      snackbarElement.style.opacity = '0';
      snackbarElement.classList.remove('show');
    }, 3000) as unknown as number;
  }
}

attemptLogout() {
  if (!confirm('Are you sure you want to leave? Changes are only saved after clicking Next and successfully completing all required fields on this page.')) {
    return
  } else {
    this.dataService.setCurrentUser(null);
    this.auth.logout();
  }
}

dismissRefreshBanner() {
  this.showRefreshBanner = false;
}


  private getCurrentComponent(): any {
    switch (this.currentPage) {
      case 0: return this.aCustomerInfo; 
      case 1: return this.bDocumentsForm;
      case 2: return this.dDirectorsAuthorityForm;
      case 3: return this.eTopCustomers;
      case 4: return this.fHealthSafety;
      default: return null;
    }
  }

  private loadUserData(user: any) {    
    console.log("Started [loadUserData]")
    this.loading = true;

      this.dataService.getCompanyByPK(user.company.intCompanyPK).subscribe((company) => {
        this.currCompany = company;
        this.formDataService.setCurrCompanyID(user.company.intCompanyPK);
        console.log(user.company.intCompanyPK)
  
        forkJoin({
          businessTypes: this.dataService.getCompanyBusinessTypes(user.company.intCompanyPK),
          contracts: this.dataService.getCompanyContracts(user.company.intCompanyPK),
          contractDetails: this.dataService.getCompanyContractDetails(user.company.intCompanyPK),
          directors: this.dataService.getCompanyDirectors(user.company.intCompanyPK),
          documents: this.dataService.getCompanyDocuments(user.company.intCompanyPK),
          hseDocs: this.dataService.getCompanyHSE(user.company.intCompanyPK),
          signatories: this.dataService.getCompanySignatories(user.company.intCompanyPK),
          subcontracts: this.dataService.getCompanySubcontracts(user.company.intCompanyPK),
          subsidiaries: this.dataService.getCompanySubsidiaries(user.company.intCompanyPK),
        }).subscribe({
          next: (responses) => {
            console.log("Responses received, saving to submittedData..")
            const normalizedName = normalizeUserNameTitle(user);
            this.submittedData = {
              user: {
                ...user,
                ...normalizedName,
                signatureFile: null,
              },
              company: { ...company },
              documents: responses.documents || {},
              companyBusTypes: responses.businessTypes || [],
              directors: responses.directors || [],
              authsignatories: responses.signatories || [],
              subsidaries: responses.subsidiaries || [],
              strPrimaryWorkSubContracted: responses.subcontracts?.map(s => s.strPrimaryWorkSubContracted) || [],
              blnAllowsSubcontracts: responses.contractDetails?.[0]?.blnAllowsSubcontracts || false,
              blnContractStatus: responses.contractDetails?.[0]?.blnContractStatus || false,
              strContractDetails: responses.contractDetails?.[0]?.strContractDetails || '',
              topcustomers: responses.contracts || [],
              hse_docs: {
                agreedToSustainabilityChecklist: false,
                ...(Array.isArray(responses.hseDocs) && responses.hseDocs.length > 0 ? responses.hseDocs[0] : (responses.hseDocs && !Array.isArray(responses.hseDocs) ? responses.hseDocs : {})),
              },
            };

            //set Local form data to what was retrieved
            this.formDataService.updateFormData(this.submittedData);
    
            console.log('Form Data Populated:', this.submittedData);
            this.loading = false;
          },
          error: (error) => {
            console.error('Error fetching related company data:', error);
            this.errorLoading = true;
             
            this.loading = false;
          }
        });
      });
    }
}


